exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCode[data-v-c64a1770],\n.operate[data-v-c64a1770] {\n  color: #1890ff;\n  font-size: 14px;\n  cursor: pointer;\n}\n", ""]);

// exports
